import { CountrySelector } from '../../../../components/selects';
import { EditorProps } from '../types/editor-props';

/**
 * Dropdown editor for ISO 3166-1 alpha-2 country codes. Thin adapter that
 * wires `CountrySelector` into the `EditorProps` contract — picking a value
 * commits immediately via `onCommit` when provided.
 */
export function CountryEditor({ id, value, onChange, onCommit, onBlur }: EditorProps) {
  return (
    <CountrySelector
      id={id}
      value={value == null ? '' : String(value)}
      defaultOpen
      autoFocus
      onChange={code => {
        if (onCommit) onCommit(code);
        else onChange(code);
      }}
      onBlur={onBlur}
    />
  );
}
